import { format } from 'date-fns';

// Utilitarios de mascara p/ documentos (CPF, CNPJ, CNH).
// Regra do projeto: no BANCO guarda-se SO OS DIGITOS (preservando zeros a
// esquerda, por isso STRING e nao INTEGER). A mascara e aplicada apenas na
// APRESENTACAO (tela via react-input-mask; impressao/modal via estas funcoes).

// remove tudo que nao for digito
export const soDigitos = (v) => (v == null ? '' : String(v).replace(/\D+/g, ''));

// 000.000.000-00 (aplica progressivamente conforme os digitos disponiveis)
export const formataCPF = (v) => {
  const d = soDigitos(v).slice(0, 11);
  if (!d) return '';
  return d
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1-$2');
};

// 00.000.000/0000-00
export const formataCNPJ = (v) => {
  const d = soDigitos(v).slice(0, 14);
  if (!d) return '';
  return d
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
};

// CNH: somente digitos (11), sem separadores
export const formataCNH = (v) => soDigitos(v).slice(0, 11);

// documento do socio: CPF se PF, CNPJ se PJ
export const formataDocumento = (v, tipo) =>
  tipo === 'PJ' ? formataCNPJ(v) : formataCPF(v);

// CPF/CNPJ generico pelo tamanho (>11 digitos -> CNPJ). Usado onde o mesmo
// campo aceita os dois (ex.: veiculo_cpf_cnpj) e nao ha um "tipo" definido.
export const formataCpfCnpj = (v) => {
  const d = soDigitos(v);
  return d.length > 11 ? formataCNPJ(d) : formataCPF(d);
};

// mascaras do react-input-mask correspondentes (para os inputs na criacao)
export const MASK_CPF = '999.999.999-99';
export const MASK_CNPJ = '99.999.999/9999-99';
export const MASK_CNH = '99999999999';
// CPF/CNPJ: react-input-mask nao suporta mascara dinamica por tamanho de forma
// nativa; onde precisar dos dois usar a mascara conforme o tipo/contexto.

// Formata data para exibição sem derrubar a tela. O `format` do date-fns lança
// RangeError com data inválida — e `new Date(undefined)` é inválido —, então uma
// coluna nullable (cnh_validade, dt_h_fim, data_emissao) ou um campo ausente no
// payload quebrava a renderização inteira, não só aquela célula. Aconteceu na
// tela de empresas da abordagem, com data vinda do webhook de MDF-e.
//
// Vazio/inválido devolve o marcador, nunca exceção.
export const formataData = (valor, padrao = 'dd/MM/yyyy', vazio = '—') => {
  if (valor === null || valor === undefined || valor === '') return vazio;

  const data = valor instanceof Date ? valor : new Date(valor);
  if (Number.isNaN(data.getTime())) return vazio;

  return format(data, padrao);
};
